import { Box } from '@mui/material';

const NewPartnerSection = ({
  children,
}: {
  children: React.ReactElement | (React.ReactElement | false)[] | false;
}) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      width='100%'
      gap='20px'
      padding='0px 16px 16px 16px'
      borderRadius={3}
    >
      {children}
    </Box>
  );
};

export default NewPartnerSection;
